<style scoped>
.product-brand {
    @apply text-xl font-extrabold;
}
.product-name {
    @apply text-2xl font-semibold;
}
.product-sales-reminder {
    @apply text-base;
}
.product-size {
    @apply text-base;
}

.product-description ::v-deep {
    @apply leading-7;
}

.text-external-urls {
    display: flex;
    flex-direction: column;
    width: 100%;
    @apply mr-8;
}

.img-external-urls {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    @apply mt-2;
}

.external-url-icon {
    width: 35px;
    height: 35px;

    & .img-ar {
        @apply rounded-lg;
    }
}
</style>

<template>
    <div class="flex flex-col scrollbar-theme">
        <div v-if="product.prodDespImgId && showProdDespImg" class="my-4">
            <img class="w-full " :src="productDespImgUrl" />
        </div>

        <div
            class="flex flex-col items-center sm:flex-row sm:flex-wrap sm:items-start"
        >
            <div
                class="product-image-wrapper w-full flex flex-shrink-0 items-start sm:w-5/12 sm:pr-4"
            >
                <productImage
                    :product="product"
                    :imageType="product.prodLrgImgId ? 'large' : 'small'"
                />
            </div>

            <div class="mt-4 sm:mt-0 sm:w-7/12 flex flex-col flex-grow">
                <div class="product-info-wrapper">
                    <div class="bg-white" v-sticky>
                        <div class="product-brand">
                            {{ product.prodBrndName }}
                        </div>
                        <contentNewLine
                            class="product-name"
                            :value="product.prodName"
                        />
                        <div class="product-size">
                            {{ product.prodSizeText }}
                        </div>
                        <div class="product-sales-reminder">
                            {{ product.prodSaleRmdrText }}
                        </div>
                    </div>

                    <div
                        class="py-3 mb-auto product-description"
                        v-html="product.prodDesp"
                    />
                </div>

                <div class="flex flex-wrap items-end">
                    <div
                        v-if="textProductLinks && textProductLinks.length"
                        class="text-external-urls"
                    >
                        <urlButton
                            v-for="pl in textProductLinks"
                            :key="pl.id"
                            class="w-full flex justify-start mt-1"
                            :url="pl.prodLinkUrl"
                            :desp="pl.prodRefLinkTypeName"
                            @openUrl="captureOpenUrlAction(pl)"
                        />
                    </div>

                    <div
                        v-if="imageProductLinks && imageProductLinks.length"
                        class="img-external-urls"
                    >
                        <urlButton
                            v-for="pl in imageProductLinks"
                            :key="pl.id"
                            class="flex justify-start mr-4"
                            :url="pl.prodLinkUrl"
                            :desp="pl.prodRefLinkTypeName"
                            @openUrl="captureOpenUrlAction(pl)"
                        >
                            <div class="external-url-icon">
                                <imageLoader
                                    :src="
                                        productLinkImageUrl(
                                            pl.prodRefLinkTypeImgId
                                        )
                                    "
                                    :srcError="img7s112"
                                />
                            </div>
                        </urlButton>
                    </div>
                </div>

                <div>
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import productImage from '@/components/productImage.vue';
import contentNewLine from '@/components/contentNewLine';
import urlButton from '@/components/urlButton.vue';
import ctx from '@/utils/ctx';
import img7s112 from '@/assets/img/7-112.png';
import imageLoader from '@/components/imageLoader.vue';
import { marketingEventHandler } from '../utils/marketingDataProcessor.js';
import sticky from '../directives/stickyDirective';

export default {
    components: {
        productImage,
        contentNewLine,
        urlButton,
        imageLoader
    },
    directives: { sticky },
    props: {
        product: { type: Object, required: true },
        productLinks: { type: Array, default: () => [] },
        showProdDespImg: { type: Boolean, default: true }
    },
    data: () => ({
        img7s112: img7s112
    }),
    computed: {
        productDespImgUrl() {
            return ctx('/productImage/' + this.product.prodDespImgId);
        },
        productLinkImageUrl() {
            return imgId => ctx('/productLinkImage/' + imgId);
        },
        textProductLinks() {
            return this.productLinks.filter(
                l => l.prodRefLinkTypeGrpCode === 'TEXT'
            );
        },
        imageProductLinks() {
            return this.productLinks.filter(
                l => l.prodRefLinkTypeGrpCode === 'IMG'
            );
        }
    },
    methods: {
        captureOpenUrlAction(productLink) {
            const addtionalInfo = ` Product Link Key: ${productLink.id} ;Link Type: [${productLink.prodRefLinkTypeGrpCode}] - ${productLink.prodRefLinkTypeName}`;
            marketingEventHandler.externalLinkClick(
                this.product.prodKey || this.product.id,
                this.product.shopListKey,
                addtionalInfo,
                productLink.trckSlctKey
            );
        }
    }
};
</script>
